module.exports = __webpack_public_path__ + "static/media/TradeGothicMedium.23940e86.otf";